export const tierValues = new Array(7).fill('').map((value, index) => index);

export const getTierLabel = (tier: number) => `Tier ${tier}`;
